import { render, staticRenderFns } from "./index.vue?vue&type=template&id=69fa601d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fa601d')) {
      api.createRecord('69fa601d', component.options)
    } else {
      api.reload('69fa601d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=69fa601d&", function () {
      api.rerender('69fa601d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/previewPDF/index.vue"
export default component.exports